exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.PolarisVue-FadeTransition--show {\n  transition: opacity 0.5s;\n}\n.PolarisVue-FadeTransition--hide {\n  opacity: 0;\n}\n", "", {"version":3,"sources":["/home/kiran-price/_polaris_vue/live/src/components/transitions/FadeTransition.vue"],"names":[],"mappings":";AAAA;EACE,yBAAyB;CAAE;AAE7B;EACE,WAAW;CAAE","file":"FadeTransition.vue","sourcesContent":[".PolarisVue-FadeTransition--show {\n  transition: opacity 0.5s; }\n\n.PolarisVue-FadeTransition--hide {\n  opacity: 0; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7144095b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transitions/FadeTransition.vue
// module id = 362
// module chunks = 0